import cn from 'classnames';
import { PrimaryButton } from 'src/shared/design-system/Buttons';
import { Modal } from 'src/shared/design-system/Modal';
import { useScreenContext } from 'web-common/src/shared/context/ScreenContext/hook';
import { useIsDishFirst } from '../../../../../../dish-first/useIsDishFirst';
import { BulkDiscountModalBody } from './BulkDiscountModalBody';
import { useBulkDiscountModalContext } from './BulkDiscountModalContext';
import { BulkDiscountModalHeader } from './BulkDiscountModalHeader';

export const BulkDiscountModal = () => {
  const { isSmallScreen } = useScreenContext();
  const { isShowing, hide, bulkDiscountTiers, discountedDeliveryFee } = useBulkDiscountModalContext();
  const { isDishFirst } = useIsDishFirst();
  if (!isDishFirst) {
    return null;
  }

  return (
    <>
      <Modal
        size='lg'
        className={cn('max-h-full overflow-hidden !p-0', { 'self-end !rounded-t-3xl': isSmallScreen })}
        isShowing={isShowing}
        onClose={() => {
          hide(true);
        }}
        isFullWidth={isSmallScreen}
        showCloseButton>
        <div className={cn('my-10 h-full overflow-y-auto')}>
          <BulkDiscountModalHeader />
          <BulkDiscountModalBody
            bulkDiscountTiers={bulkDiscountTiers}
            deliveryFree={4000}
            discountedDeliveryFee={discountedDeliveryFee}
            loading={false}
          />
          <div className='mx-auto w-80'>
            <PrimaryButton className='w-full !rounded-lg' onClick={hide}>
              Shop now
            </PrimaryButton>
          </div>
        </div>
      </Modal>
    </>
  );
};
